import { Injectable } from '@angular/core';
import { ResourceVm } from 'qp-ui-interface';
import { TabService } from '../../../shared/services/tabs/tab.service';
import {
  ChannelInfo,
  CollectionInfo,
  ContainerInfo,
  ContentInfo,
  TabInfo,
} from './../model/newrelic.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NewrelicContentStore {
  private currentResource: ResourceVm;
  constructor(
    private tabService: TabService,
    private translate: TranslateService
  ) {}

  public setContentDetails(resource: ResourceVm) {
    this.currentResource = resource;
  }

  public getContentDetails(): ResourceVm {
    return this.currentResource;
  }

  public getCollectionInfo(): CollectionInfo {
    return {
      collectionID: this.currentResource?.collectionID || undefined,
      collectionName:
        (this.currentResource?.collectionName &&
          this.currentResource?.collectionName[
            this.translate.currentLang || 'en'
          ]) ||
        undefined,
    };
  }

  public getTabInfo(): TabInfo {
    return {
      tabID: this.tabService?.currentTabId,
      tabName: this.tabName(),
    };
  }

  private tabName(): string {
    let tabName: string = '';
    // console.log('NEW this.tabService?.tabsInfo', this.tabService?.tabsInfo);
    this.tabService?.tabsInfo.filter((info) => {
      if (info?.name['en'] === this.tabService?.currentTabName['en']) {
        if (info?.name !== undefined && info?.name['en'] !== undefined) {
          tabName =
            info?.name['en'] === 'all' || info?.name['en'] === 'All'
              ? 'home'
              : info?.name['en'];
        }
      }
    });
    if (!tabName) {
      tabName = this.tabService?.currentTabName['en'];
    }
    return tabName;
  }

  public getChannelInfo(): ChannelInfo {
    const lang = this.translate.currentLang || 'en';
    return this.currentResource?.contentType === 'channel'
      ? {
          channelName: this.currentResource?.title?.[lang] || undefined,
          channelID: this.currentResource?.id,
        }
      : undefined;
  }

  public getContainerInfo(): ContainerInfo {
    const lang = this.translate.currentLang || 'en';
    const containerName =
      this.currentResource?.containerName &&
      this.currentResource.containerName[lang]?.toLowerCase() === 'highlights'
        ? 'Hero'
        : (this.currentResource?.containerName &&
            this.currentResource.containerName[lang]) ||
          undefined;
    return {
      containerID: this.currentResource?.containerId || undefined,
      containerName: containerName || undefined,
    };
  }

  public getContentInfo(): ContentInfo {
    const lang = this.translate.currentLang || 'en';
    return {
      storefrontID:
        localStorage.getItem('storefrontId') ||
        localStorage.getItem('CurrentStorefrontId'),
      providerID: this.currentResource?.providerName,
      contentKey: this.currentResource?.key,
      contentID: this.currentResource?.id,
      contentType: this.currentResource?.contentType,
      contentGenre: this.currentResource?.contentGenre?.[lang]
        ? this.currentResource?.contentGenre?.[lang].toString()
        : undefined,
      contentName: this.currentResource?.title?.[lang] || undefined,
      seriesName:
        this.currentResource?.isSeries && this.currentResource?.seriesTitle
          ? this.currentResource?.seriesTitle?.[lang] || undefined
          : undefined,
      isFreePreview: this.currentResource?.freePreview !== undefined,
      episodeNumber: this.currentResource?.episodeNumber
        ? this.currentResource.episodeNumber.toString()
        : undefined,
      seasonNumber: this.currentResource?.seasonNumber
        ? this.currentResource.seasonNumber.toString()
        : undefined,
    };
  }
}
